import posthog from 'posthog-js';

type PostHogProperties = Record<string, string | number | boolean>;

export const trackEvent = (
  eventName: string,
  properties?: PostHogProperties
): void => {
  posthog.capture(eventName, properties);
};
